import { Box } from '../box/box';
import { StatusTag } from './status-tag';

const StatusLabel = ({
  on,
  onLabel = 'Active',
  offLabel = 'Inactive',
}: {
  on: boolean;
  onLabel?: string;
  offLabel?: string;
}) => (
  <StatusTag tone={on ? 'success' : 'neutral'}>
    {on ? onLabel : offLabel}
  </StatusTag>
);

// Grid column renderer for a boolean value: `renderCell: renderStatusCell()`.
// The value (and so filtering / sorting) stays the plain boolean.
export const renderStatusCell =
  (onLabel?: string, offLabel?: string) =>
  ({ value }: { value?: unknown }) =>
    (
      <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
        <StatusLabel on={!!value} onLabel={onLabel} offLabel={offLabel} />
      </Box>
    );
